import type { LabeledValue } from 'antd/es/select';
import { default as Select } from 'antd/es/select';
import { default as Space } from 'antd/es/space';
import { useMemo } from 'react';

import { filterOption } from 'utils/antd/filters-option';

import { LocalDateRangeWrapper } from '@molecules/LocalDateRangeWrapper';

import { BATCHES_STATUS_FILTER_TEST_ID, BATCHES_STATUSES } from './constants';
import type { FiltersState } from './localState';

type Props = {
  isBatchApprovalRequired: boolean;
  filters: FiltersState;
  setFilters: (filters: FiltersState) => void;
};

export const BatchesFilters = ({
  isBatchApprovalRequired,
  filters,
  setFilters
}: Props) => {
  const defaultValue = useMemo(
    () =>
      BATCHES_STATUSES.find(
        (state) => state.value === filters.status
      ) as LabeledValue,
    [filters.status]
  );

  return (
    <div className="flex items-center">
      <Space wrap size="small">
        <LocalDateRangeWrapper />

        {/* Status */}
        {isBatchApprovalRequired && (
          <Select
            showSearch
            filterOption={filterOption}
            data-testid={BATCHES_STATUS_FILTER_TEST_ID}
            options={BATCHES_STATUSES}
            defaultValue={defaultValue}
            style={{ width: 160 }}
            popupMatchSelectWidth={false}
            onChange={(chosenOption: LabeledValue) => {
              setFilters({
                status: chosenOption as unknown as typeof filters.status
              });
            }}
          />
        )}
      </Space>
    </div>
  );
};
